// Copyright 2020
//   __  __                       _           _     _   _            _ _   _     
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__  
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \ 
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//                                                                              
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/actuator/v1/online_offline.proto (package msh.trait.actuator.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Agent } from "../../../common/v1/common_pb";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * *
 * A binary state to represent online or offline.
 *
 * @generated from message msh.trait.actuator.v1.OnlineOfflineTrait
 */
export const OnlineOfflineTrait = proto3.makeMessageType(
  "msh.trait.actuator.v1.OnlineOfflineTrait",
  () => [
    { no: 1, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * ----- EVENTS -----//
 *
 * @generated from message msh.trait.actuator.v1.OnlineOfflineTrait.OnlineOfflineChangedEvent
 */
export const OnlineOfflineTrait_OnlineOfflineChangedEvent = proto3.makeMessageType(
  "msh.trait.actuator.v1.OnlineOfflineTrait.OnlineOfflineChangedEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "trait", kind: "message", T: OnlineOfflineTrait },
    { no: 3, name: "agent", kind: "message", T: Agent },
    { no: 4, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
  ],
  {localName: "OnlineOfflineTrait_OnlineOfflineChangedEvent"},
);

/**
 * ----- COMMANDS -----//
 *
 * @generated from message msh.trait.actuator.v1.OnlineOfflineTrait.SetState
 */
export const OnlineOfflineTrait_SetState = proto3.makeMessageType(
  "msh.trait.actuator.v1.OnlineOfflineTrait.SetState",
  () => [
    { no: 1, name: "trait", kind: "message", T: OnlineOfflineTrait },
  ],
  {localName: "OnlineOfflineTrait_SetState"},
);

